<template>
  <div v-if="visible" class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content">
      <div class="modal-header" style="justify-content: space-between;">
        <h3 style="font-size: 24px; font-weight: 500; line-height: 1.33333333;">
          Популярные аккумуляторы для подбора
        </h3>
        <button @click="$emit('close')" class="btn-close-modal"></button>
      </div>

      <BatteryTable
        v-if="hasProducts('exact')"
        :title="'Точная модель'"
        :batteries="getFlatProducts('exact')"
        :link="batteries.exact.link"
        :isProductInOrder="isProductInOrder"
        @add-product="handleAddProduct"
        :managersDict="managersDict"
      />

      <BatteryTable
        v-if="showSimilar && hasProducts('similar')"
        :title="'Другие двигатели этой модели'"
        :batteries="getFlatProducts('similar')"
        :link="batteries.similar.link"
        :isProductInOrder="isProductInOrder"
        @add-product="handleAddProduct"
        :managersDict="managersDict"

      />

      <BatteryTable
        v-if="showModel && hasProducts('model')"
        :title="'Общая модель'"
        :batteries="getFlatProducts('model')"
        :link="batteries.model.link"
        :isProductInOrder="isProductInOrder"
        @add-product="handleAddProduct"
        :managersDict="managersDict"
      />



       <div v-if="isloadText" class="loadText"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff"><path fill-rule="evenodd" d="M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z" clip-rule="evenodd"/></svg>
        Загрузка займет больше времени, пожалуйста, подождите еще
      </div>

       <div v-if="!showSimilar || !showModel" class="load-more-btn-container">
        <button class="load-more-btn" @click="loadMore" :disabled="isLoadingMore">
          {{ isLoadingMore ? 'Загрузка...' : 'Показать ещё' }}
        </button>
      </div>


    </div>
  </div>
</template>

<script>import { ORDERS_API_BASE } from '@/config/api';

import BatteryTable from './BatteryTable.vue';

export default {
  name: 'PopularBatteriesModal',
  components: {
    BatteryTable
  },
  data() {
    return {
      showSimilar: false,
      showModel: false,
      isLoadingMore: false,
      isloadText: false
    };
  },
  props: {
    visible: Boolean,
    batteries: {
      type: Object,
      required: true
    },
    isProductInOrder: {
      type: Function,
      required: true
    },
    managersDict: Array
  },
  methods: {
    async loadMore() {
      this.isLoadingMore = true;
      // Начинаем таймер на 30 секунд
      const timeoutId = setTimeout(() => {
        this.isloadText = true;
      }, 10000);
      try {
        
        const response = await fetch(`${ORDERS_API_BASE}/popular-batteries.php?link=${encodeURIComponent(this.batteries.exact.link)}&expand=1`);
        const data = await response.json();
        clearTimeout(timeoutId); // Очищаем таймер, если запрос завершился раньше

        if (data.success && data.batteries) {
          if (data.batteries.similar) {
            this.batteries.similar = data.batteries.similar;
            this.showSimilar = true;
            
          }

          if (data.batteries.model) {
            this.batteries.model = data.batteries.model;
            this.showModel = true;
          }
        }
      } catch (err) {
        console.error('Ошибка загрузки расширенных данных:', err);
        clearTimeout(timeoutId);
      } finally {
        this.isLoadingMore = false;
        this.isloadText = false;
      }
    },
    handleAddProduct(product) {
      this.$emit('add-product', product);
    },
    hasProducts(type) {
      return (
        this.batteries[type] &&
        Array.isArray(this.batteries[type].products) &&
        this.batteries[type].products.length > 0
      );
    },

    getFlatProducts(type) {
      const list = this.batteries[type] && Array.isArray(this.batteries[type].products)
        ? this.batteries[type].products
        : [];

      return list
        .map(item => {
          const product = item.products && item.products.length ? item.products[0] : null;
          if (!product) return null;

          return {
            ...product,
            _salesCount: item.count,
            _salesQty: item.totalQty,
            managers: item.managers || []
          };
        })
        .filter(Boolean);
    }

  }
};
</script>


<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 24px;
  margin: 50px auto;
  width: 90%;
  max-width: 1340px;
  border-radius: 6px;
}

.modal-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.btn-close-modal {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  line-height: 1;
}

.load-more-btn-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.load-more-btn {
  padding: 10px 20px;
  background-color: #22c993;
  background-image: linear-gradient(180deg, #22c993, #20a77f);
  color: white;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s, background-color 0.2s;
  min-width: 160px;
}

.load-more-btn:hover {
  opacity: 0.85;
}

.load-more-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  opacity: 0.6;
}
.loadText {
  padding: 10px 10px;
  border-radius: 5px;
  text-align: center;
  margin: auto;
  margin-top: 20px;
}
.loadText svg {
  fill: #000;
}
</style>
